import { z } from 'zod'

export enum SlotAvailability {
  None = 0,
  AmAvailable = 1 << 0,
  PmAvailable = 1 << 1,
  BothAvailable = (1 << 0) | (1 << 1),
}

// export const TimeSlot = z.object({
//   slot: z.string(),
//   disabled: z.boolean(),
// })

// export const CourierDeliveryScheduleSchema = z.object({
//   date: z.string().date(),
//   timeSlots: z.array(TimeSlot),
// })

export const CourierDeliveryScheduleSchema = z.object({
  deliveryDate: z.string().date(),
  slotAvailability: z.nativeEnum(SlotAvailability),
})

export type CourierDeliverySchedule = z.infer<typeof CourierDeliveryScheduleSchema>

export const ServiceabilitySchema = z.object({
  serviceable: z.boolean(),
  postcode: z.string(),
  suburb: z.string(),
})

export type Serviceability = z.infer<typeof ServiceabilitySchema>
